var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQrRechazado = function SvgQrRechazado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "qr_rechazado_svg__Capa_2",
    viewBox: "0 0 12.7 12.7"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr_rechazado_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.58,
    height: 3.21,
    x: -1.94,
    y: 4.74,
    rx: 1.56,
    ry: 1.56,
    transform: "rotate(45 6.35 6.35)",
    fill: "#ff7595"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.58,
    height: 3.21,
    x: -1.94,
    y: 4.74,
    rx: 1.56,
    ry: 1.56,
    transform: "rotate(-45 6.35 6.35)",
    fill: "#ff4772"
  }))));
};
export default SvgQrRechazado;